<h2 class="text-center"> Loading New Country</h2>
<form [formGroup]="myForm" (ngSubmit)="submit()" *ngIf="!loading" enctype="multipart/form-data">
  <div class="form-group row mt-2" [ngClass]="{error:f.shortName.errors && f.shortName.touched}">
    <label for="shortName" class='control-label col-sm-3'>Short Name<span class="required-asteric">*</span></label>
        <div class="col-sm-8">
          <input type="text" id="shortName" formControlName="shortName" class="form-control">
            <div *ngIf="f.shortName.errors && f.shortName.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Short Name Required.</li>
                </ul>
            </div>
        </div>
</div>
<div class="form-group row mt-2" [ngClass]="{error:f.educationSystem.errors && f.educationSystem.touched}">
  <label for="educationSystem" class='control-label col-sm-3'>educationSystem<span class="required-asteric">*</span></label>
      <div class="col-sm-8">
          <select class="form-control" id="educationSystem"   formControlName="educationSystem">
              <option *ngFor="let educationSystem of educationSystems" [value]="educationSystem['id']">{{educationSystem['name']}}</option>
          </select>
          <div *ngIf="f.educationSystem.errors && f.educationSystem.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
              <ul>
                  <li>Education System  is required.</li>
              </ul>
          </div>
      </div>
</div>
    <div class="form-group row">
        <label for="file" class='control-label col-sm-3'>File</label>
        <div class=' col-sm-8'>
        <input
            formControlName="file"
            id="file"
            type="file"
            class="form-control"
            (change)="onFileChange($event)">
            <div *ngIf="f.file.touched && f.file.invalid" class="alert alert-danger">
                <div *ngIf="f.file.errors.required">File is required.</div>
            </div>
          </div>
        </div>


        <fieldset class="text-center mt-2">
            <button [disabled]="loading" class="btn btn-primary me-4" type="submit">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> Submit
            </button>
            <a class="btn btn-secondary" [routerLink]="['/task/template/list']"> Close</a>
        </fieldset>
</form>
